import { CredentialEntity } from '@uploadcam/common';

/**
 * Check post conditions after login.
 */
export interface CheckLoginPostConditionsInteractor {
  execute(credential: Readonly<CredentialEntity>): Promise<void>;
}

export class CheckLoginPostConditionsNoopInteractor implements CheckLoginPostConditionsInteractor {
  public async execute(_credential: Readonly<CredentialEntity>): Promise<void> {
    // Noop
  }
}
